import React, { FC } from 'react';
import styles from './Footer.module.scss';
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import { CustomLink } from '../CustomLink';

const Footer: FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const withContrast = true;
  return (
    <footer className={styles.footer}>
      <Container>
        <ul className={styles.ul}>
          <li>
            <CustomLink to={`/${language}/impressum`} shouldScrollToTop>{t('footer.imprint')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/support`} shouldScrollToTop>{t('footer.support')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/support`} shouldScrollToTop>{'Inhalt melden'}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/jugendschutz`} shouldScrollToTop>{t('footer.youthProtection')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/datenschutz`} shouldScrollToTop>{t('footer.privacyPolicy')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/agb`} shouldScrollToTop>{t('footer.termsAndConditions')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/preise`} shouldScrollToTop>{t('footer.price')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/barrierefreiheitserklaerung`} shouldScrollToTop>{t('footer.eaaFooter')}</CustomLink>
          </li>
          <li>
            <CustomLink to={`/${language}/faq`} shouldScrollToTop>FAQ</CustomLink>
          </li>
        </ul>
        <br />
        <CustomLink className={styles.statement} to={`/${language}/18-U-S-C`} shouldScrollToTop>
          18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement
        </CustomLink>
        <div className={styles.buttonTop}>
          <button
            className={withContrast ? styles.contrast : ''}
                      onClick={scrollTop}>
            <i className="fa fa-chevron-up"></i>
          </button>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
